import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { Emdash } from "~/components/Punctuation/Emdash";
import { DataGridNumberPercentChangeComboCell } from "~/components/DataGrid/DataGridNumberPercentChangeComboCell";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

// // // //

export const APY_7_DAY_COLUMN: ColumnMetadata<AssetTableRowData, AssetColumns> =
    {
        slug: AssetColumns.apy7Day,
        label: "7D APY",
        tooltip: CatalogMetricSlugs.apy_7_day,
        type: ColumnTypes.percent,
        sortsOn: AssetColumns.apy7Day,
        width: 125,
        loginRequired: true,
        render: (item) => {
            if (!item.isAsset) {
                return <Emdash />;
            }

            const measure = getMeasureValue(item, "apy_7_day");

            if (measure === null) {
                return <Emdash />;
            }

            return (
                <DataGridNumberPercentChangeComboCell
                    value={measure.val / 100}
                    pct_change_interval="7d"
                    pct_change_value={measure.chg_7d_pct}
                    type="percent"
                />
            );
        },
    };
